import { render, staticRenderFns } from "./CountryView.vue?vue&type=template&id=2936579c"
import script from "./CountryView.vue?vue&type=script&lang=js"
export * from "./CountryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports